import {Component} from 'react';

import {store} from '../AppRenderer';

class Rbac extends Component {

  static hasPermission(permission) {
    if(!permission){
      return true;
    }
    const permissions = store.getState().menu.permissions;
    return permissions && (permissions.includes(permission) || permissions.includes('*'));
  }

  render() {
    const {permission,children} = this.props;
    return Rbac.hasPermission( permission) ? children : null;
  }
}



export default Rbac;
